import { useState, useCallback } from 'react';

interface ConfirmOptions {
  type?: 'warning' | 'error' | 'info';
  okText?: string;
  cancelText?: string;
}

interface ConfirmModalState {
  isOpen: boolean;
  message: string;
  type: 'warning' | 'error' | 'info';
  okText: string;
  cancelText: string;
  resolve: (value: boolean) => void;
}

export const useConfirmModal = () => {
  const [modalState, setModalState] = useState<ConfirmModalState | null>(null);

  const showConfirm = useCallback((message: string, options: ConfirmOptions = {}): Promise<boolean> => {
    return new Promise((resolve) => {
      setModalState({
        isOpen: true,
        message,
        type: options.type || 'warning',
        okText: options.okText || 'Confirm',
        cancelText: options.cancelText || 'Cancel',
        resolve
      });
    });
  }, []);

  const handleConfirm = useCallback(() => {
    if (modalState) {
      modalState.resolve(true);
      setModalState(null);
    }
  }, [modalState]);

  const handleCancel = useCallback(() => {
    if (modalState) {
      modalState.resolve(false);
      setModalState(null);
    }
  }, [modalState]);

  return {
    modalState,
    showConfirm,
    handleConfirm,
    handleCancel
  };
}; 